import { AssortmentType } from '../model/customer'

export const useAssortmentType = () => {
  const isAfa = window.location.href.includes('afa')

  return isAfa ? 'afa' : ('frames' as AssortmentType)
}
